<template>
  <div class="totalFleet">
    <el-drawer size="80%" title="车队长总数" :data="visible" :visible.sync="visible" :before-close="cancelModal">
      <basic-container>
        <searchInfo :info="paramsSearch" :type="3" source="2" @searchChange="searchChange" @exOut="exOut">
          <template slot="count">
            <div class="count">车队长总数 <span>{{ count }}个</span></div>
          </template>
        </searchInfo>
        <avue-crud ref="crud" :page.sync="page" :data="tableData" :table-loading="tableLoading" :option="tableOption"
          v-model="form" :search.sync="search" @on-load="getPage">
          <template slot="mobile" slot-scope="{row}">
            <span>{{ row.mobile.replace(/^(.{4})(?:\d+)(.{3})$/, '\$1******\$2') }}</span>
          </template>
          <template slot="idCard" slot-scope="{row}">
            <span>{{ row.idCard.replace(/^(.{4})(?:\d+)(.{3})$/, '\$1******\$2') }}</span>
          </template>
          <template slot="bindingBankNo" slot-scope="{row}">
            <span>{{ row.bindingBankNo.replace(/^(.{4})(?:\d+)(.{3})$/, '\$1******\$2') }}</span>
          </template>
        </avue-crud>
      </basic-container>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDriverCaptainPage as getPage } from "@/api/chain/board";
import searchInfo from './searchInfo';
import { exportOut } from "@/util/down.js";

export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  components: {
    searchInfo
  },
  data () {
    return {
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [],//升序字段
        descs: []//降序字段
      },
      form: {},
      search: {},
      tableData: [],
      paramsSearch: {},
      tableLoading: false,
      tableOption: {
        dialogDrag: false,
        border: true,
        indexLabel: "序号",
        stripe: true,
        align: "center",
        searchShow: false,
        labelWidth: 150,
        // maxHeight:[800],
        // height:'auto',
        excelBtn: false,
        printBtn: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        index: true,
        refreshBtn: false,
        columnBtn: false,
        menu: false,
        header: false,
        column: [
          {
            label: "车队长",
            prop: "name",
            minWidth: 80,
            overHidden: true,
          },
          {
            label: "车队数量",
            prop: "fleetCount",
            minWidth: 70,
            overHidden: true,
          },
          {
            label: "运单数",
            prop: "waybillCount",
            minWidth: 70,
            overHidden: true,
          },
          {
            label: "手机号",
            prop: "mobile",
            minWidth: 100,
            overHidden: true,
          },
          {
            label: "是否实名",
            prop: "realNameAuthentication",
            minWidth: 80,
            overHidden: true,
          },
          {
            label: "身份证号",
            prop: "idCard",
            minWidth: 160,
            overHidden: true,
          },
          {
            label: "银行卡号",
            prop: "bindingBankNo",
            minWidth: 160,
            overHidden: true,
          },
          {
            label: "创建时间",
            prop: "captainCreateDatetime",
            minWidth: 140,
            overHidden: true,
          },
        ],
      },
      count: 0
    }
  },
  created () {
    this.paramsSearch = Object.assign({}, this.info)
    this.count = this.info.count
  },
  mounted () {
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    cancelModal () {
      this.$emit("update:visible", false);
    },
    searchChange (params, done) {
      params = this.filterForm(params);
      this.paramsSearch = params;
      this.page.currentPage = 1;
      this.getPage(this.page, params);
      done();
    },
    getPage (page, params) {
      this.tableLoading = true;
      getPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
          this.count = response.data.data.total || 0
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    exOut (params, done) {
      let url = "/chain/statisticsboard/exportDriverCaptainExcel";
      exportOut(params, url, "车队长总数", 'get').then(res => {
        done()
      }).catch(() => {
        done()
      })
    },
  },

};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer__header {
  margin-bottom: 10px;
}

.count {
  margin-bottom: 10px;

  span {
    font-size: 16px;
    font-weight: 700;
  }
}
</style>
